import React, { useEffect, useState } from "react";
import {
  useJobsPopularCategoryList,
} from "Constant/apiHooks";
import { LoadingScreen } from "Components";
import { unAuthService } from "Service/Axios";
import { getJobsListUrl } from "Constant/api";
import { JobBox } from "Components/Public/JobBox";

export default function Jobs() {
  const [loading, setLoading] = useState(false);
  const [featuredJobsList, setFeaturedJobsList] = useState([]);

  const { jobsPopularCategoryList, loading: jobsPopularCategoryListLoading } =
    useJobsPopularCategoryList();

  const fetchFeaturedJobsList = async () => {
    setLoading(true);
    const payload = { featured: true };
    const response = await unAuthService(getJobsListUrl, "POST", payload);
    setFeaturedJobsList(response.data);
    setLoading(false);
  };

  useEffect(() => {
    fetchFeaturedJobsList();
  }, []);

  return (
    <main>
      <section className="py-lg-20 py-10 text-white bg-primary-800 position-relative min-h-550 d-flex flex-column justify-content-center">
        <div className="position-absolute top-0 start-0 bottom-0 end-0 text-center intro-pattern opacity-50 overflow-hidden">
          <div className="blur-2 bg-indigo-700 opacity-50"></div>
          <div className="blur-3 bg-primary-500 opacity-50"></div>
          <div className="blur-4 bg-primary-700 opacity-50"></div>
        </div>
        <div className="container-xl position-relative z-1">
          <div className="row justify-content-center">
            <div className="col-xxl-9 col-xl-9 col-lg-12 col-md-12 col-sm-12 col-12">
              <div className="text-center">
                <h2 className="text-xxl-12xl text-xl-10xl text-lg-8xl text-md-5xl text-2xl font-bold mb-5 max-w-550 mx-auto">
                  Find a job that suits your interest & skills.
                </h2>
                <p className="text-xl font-medium mb-8">
                  Aliquam vitae turpis in diam convallis finibus in at risus.
                  Nullam in scelerisque leo.
                </p>
              </div>

              <div className="max-w-650 mx-auto">
                <div className="d-flex flex-sm-row flex-column gap-3">
                  <div className="position-relative flex-auto-1">
                    <span className="position-absolute w-14 h-100 z-10 text-primary-800 text-2xl d-flex justify-content-center align-items-center">
                      <i className="bx bx-search"></i>
                    </span>
                    <input
                      type="text"
                      className="form-control form-control-xl pl-12 pr-32 rounded-lg border-transparent"
                      placeholder="Job tittle, Keyword..."
                    />
                    <button className="btn btn-primary px-6 position-absolute top-2 right-2 bottom-2">
                      Find Job
                    </button>
                  </div>
                  <button className="btn btn-secondary btn-xl rounded-lg font-medium text-white text-nowrap">
                    Sign up today!
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-lg-20 py-10 bg-primary-50">
        <div className="container-xl">
          <div className="row justify-content-center align-items-center gx-xl-5 mb-5">
            <div className="col-xl-7 col-lg-10 col-md-12 col-sm-12 col-12 text-center">
              <h2 className="text-xl-8xl text-md-6xl text-sm-4xl text-xl font-bold">
                How PlutoEdu Jobs work
              </h2>
              <p>
                Our drag-and-drop form builder adapts to every program—from
                undergrad admissions to faculty recruitments. Just pick, place,
                and publish.
              </p>
            </div>
          </div>

          <div className="row justify-content-center align-items-center gx-xl-5">
            <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12 text-center">
              <div className="job-works-list p-4 rounded-lg d-flex flex-column row-gap-3 align-items-center position-relative">
                <span className="position-absolute works-step-arrow-up">
                  <img src="/assets/images/work-arrows.svg" alt="" />
                </span>
                <div className="job-works-icon w-16 h-16 rounded-circle d-flex justify-content-center align-items-center border border-primary-500">
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      opacity="0.2"
                      d="M16 20C20.4183 20 24 16.4183 24 12C24 7.58172 20.4183 4 16 4C11.5817 4 8 7.58172 8 12C8 16.4183 11.5817 20 16 20Z"
                      fill="#0A65CC"
                      className="fill-color"
                    />
                    <path
                      d="M22 7H28"
                      stroke="#0A65CC"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M25 4V10"
                      stroke="#0A65CC"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M3.87354 26.9988C5.10298 24.8708 6.87079 23.1037 8.99938 21.8752C11.128 20.6467 13.5424 20 16 20C18.4577 20 20.8721 20.6468 23.0007 21.8754C25.1292 23.1039 26.897 24.871 28.1264 26.9991"
                      stroke="#0A65CC"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M23.5066 14.7728C22.9718 16.2167 22.0316 17.4754 20.7988 18.3979C19.566 19.3203 18.0931 19.8672 16.557 19.9728C15.021 20.0784 13.4871 19.7383 12.1396 18.9933C10.7922 18.2483 9.68847 17.1301 8.96112 15.773C8.23377 14.416 7.91371 12.8778 8.03938 11.3432C8.16505 9.80864 8.7311 8.34301 9.66954 7.12236C10.608 5.90172 11.8789 4.97798 13.3296 4.46212C14.7803 3.94627 16.3491 3.86023 17.8475 4.21436"
                      stroke="#0A65CC"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>

                <div>
                  <h4 className="text-md font-semibold">Create account</h4>
                  <p className="text-grey-500">
                    Aliquam facilisis egestas sapien, nec tempor leo tristique
                    at.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12 text-center">
              <div className="job-works-list p-4 rounded-lg d-flex flex-column row-gap-3 align-items-center position-relative">
                <span className="position-absolute works-step-arrow-down">
                  <img src="/assets/images/work-arrows.svg" alt="" />
                </span>
                <div className="job-works-icon w-16 h-16 rounded-circle d-flex justify-content-center align-items-center border border-primary-500">
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      opacity="0.2"
                      d="M10 15.9981C10 14.0202 10.5865 12.0868 11.6853 10.4423C12.7841 8.79786 14.3459 7.51613 16.1732 6.75926C18.0005 6.00238 20.0111 5.80435 21.9509 6.1902C23.8907 6.57605 25.6726 7.52846 27.0711 8.92698C28.4696 10.3255 29.422 12.1073 29.8079 14.0471C30.1937 15.987 29.9957 17.9976 29.2388 19.8249C28.482 21.6521 27.2002 23.2139 25.5557 24.3127C23.9112 25.4116 21.9778 25.9981 20 25.9981H9.00003C8.00733 25.9971 7.02618 25.785 6.12172 25.3758C5.21725 24.9667 4.41016 24.3698 3.754 23.6249C3.09785 22.88 2.60764 22.004 2.31591 21.0551C2.02419 20.1063 1.93762 19.1062 2.06196 18.1213C2.1863 17.1364 2.51869 16.1892 3.03708 15.3426C3.55548 14.496 4.24801 13.7694 5.06871 13.2109C5.88942 12.6524 6.81952 12.2749 7.79729 12.1033C8.77507 11.9318 9.77814 11.9702 10.7399 12.216"
                      fill="#0A65CC"
                      className="fill-color"
                    />
                    <path
                      d="M11.9995 25.998H8.99954C8.00684 25.9971 7.02569 25.785 6.12123 25.3758C5.21677 24.9667 4.40967 24.3698 3.75352 23.6249C3.09736 22.88 2.60715 22.004 2.31543 21.0551C2.0237 20.1063 1.93714 19.1062 2.06147 18.1213C2.18581 17.1364 2.5182 16.1892 3.0366 15.3426C3.55499 14.496 4.24752 13.7694 5.06822 13.2109C5.88893 12.6524 6.81903 12.2749 7.79681 12.1033C8.77458 11.9318 9.77765 11.9702 10.7394 12.216"
                      stroke="#0A65CC"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M9.99902 15.998C9.99918 14.4136 10.3758 12.8518 11.098 11.4415C11.8201 10.0312 12.867 8.81262 14.1524 7.88625C15.4378 6.95988 16.925 6.35221 18.4914 6.11333C20.0577 5.87445 21.6584 6.01118 23.1615 6.51227C24.6647 7.01335 26.0272 7.86445 27.1369 8.99541C28.2466 10.1264 29.0717 11.5048 29.5441 13.0172C30.0166 14.5296 30.1229 16.1326 29.8543 17.6941C29.5857 19.2557 28.9499 20.731 27.9993 21.9986"
                      stroke="#0A65CC"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M14.7563 20.2408L18.999 15.998L23.2416 20.2408"
                      stroke="#0A65CC"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M18.999 25.998V15.998"
                      stroke="#0A65CC"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>

                <div>
                  <h4 className="text-md font-semibold">Upload CV/Resume</h4>
                  <p className="text-grey-500">
                    Curabitur sit amet maximus ligula. Nam a nulla ante. Nam
                    sodales
                  </p>
                </div>
              </div>
            </div>

            <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12 text-center">
              <div className="job-works-list p-4 rounded-lg d-flex flex-column row-gap-3 align-items-center position-relative">
                <span className="position-absolute works-step-arrow-up">
                  <img src="/assets/images/work-arrows.svg" alt="" />
                </span>
                <div className="job-works-icon w-16 h-16 rounded-circle d-flex justify-content-center align-items-center border border-primary-500">
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      opacity="0.2"
                      d="M14.4995 24.9995C20.2985 24.9995 24.9995 20.2985 24.9995 14.4995C24.9995 8.70052 20.2985 3.99951 14.4995 3.99951C8.70052 3.99951 3.99951 8.70052 3.99951 14.4995C3.99951 20.2985 8.70052 24.9995 14.4995 24.9995Z"
                      fill="#0A65CC"
                      className="fill-color"
                    />
                    <path
                      d="M10.4995 14.5H18.4995"
                      stroke="#0A65CC"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M14.4995 10.5V18.5"
                      stroke="#0A65CC"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M14.4995 24.9995C20.2985 24.9995 24.9995 20.2985 24.9995 14.4995C24.9995 8.70052 20.2985 3.99951 14.4995 3.99951C8.70052 3.99951 3.99951 8.70052 3.99951 14.4995C3.99951 20.2985 8.70052 24.9995 14.4995 24.9995Z"
                      stroke="#0A65CC"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M21.9238 21.9246L27.9989 27.9996"
                      stroke="#0A65CC"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>

                <div>
                  <h4 className="text-md font-semibold">Find suitable job</h4>
                  <p className="text-grey-500">
                    Phasellus quis eleifend ex. Morbi nec fringilla nibh.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12 text-center">
              <div className="job-works-list p-4 rounded-lg d-flex flex-column row-gap-3 align-items-center">
                <div className="job-works-icon w-16 h-16 rounded-circle d-flex justify-content-center align-items-center border border-primary-500">
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      opacity="0.2"
                      d="M6.80761 25.1924C5.65711 24.0419 6.42019 21.6265 5.8346 20.2111C5.22755 18.744 3 17.5631 3 16C3 14.4368 5.22756 13.256 5.8346 11.7888C6.4202 10.3735 5.65711 7.95811 6.80761 6.80761C7.95811 5.65711 10.3735 6.42019 11.7889 5.8346C13.256 5.22755 14.4369 3 16 3C17.5632 3 18.744 5.22756 20.2112 5.8346C21.6265 6.4202 24.0419 5.65711 25.1924 6.80761C26.3429 7.95811 25.5798 10.3735 26.1654 11.7889C26.7725 13.256 29 14.4369 29 16C29 17.5632 26.7724 18.744 26.1654 20.2112C25.5798 21.6265 26.3429 24.0419 25.1924 25.1924C24.0419 26.3429 21.6265 25.5798 20.2111 26.1654C18.744 26.7725 17.5631 29 16 29C14.4368 29 13.256 26.7724 11.7888 26.1654C10.3735 25.5798 7.95811 26.3429 6.80761 25.1924Z"
                      fill="#0A65CC"
                      className="fill-color"
                    />
                    <path
                      d="M6.80761 25.1924C5.65711 24.0419 6.42019 21.6265 5.8346 20.2111C5.22755 18.744 3 17.5631 3 16C3 14.4368 5.22756 13.256 5.8346 11.7888C6.4202 10.3735 5.65711 7.95811 6.80761 6.80761C7.95811 5.65711 10.3735 6.42019 11.7889 5.8346C13.256 5.22755 14.4369 3 16 3C17.5632 3 18.744 5.22756 20.2112 5.8346C21.6265 6.4202 24.0419 5.65711 25.1924 6.80761C26.3429 7.95811 25.5798 10.3735 26.1654 11.7889C26.7725 13.256 29 14.4369 29 16C29 17.5632 26.7724 18.744 26.1654 20.2112C25.5798 21.6265 26.3429 24.0419 25.1924 25.1924C24.0419 26.3429 21.6265 25.5798 20.2111 26.1654C18.744 26.7725 17.5631 29 16 29C14.4368 29 13.256 26.7724 11.7888 26.1654C10.3735 25.5798 7.95811 26.3429 6.80761 25.1924Z"
                      stroke="#0A65CC"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M21.5 13L14.1666 20L10.5 16.5"
                      stroke="#0A65CC"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>

                <div>
                  <h4 className="text-md font-semibold">Apply job</h4>
                  <p className="text-grey-500">
                    Curabitur sit amet maximus ligula. Nam a nulla ante, Nam
                    sodales purus.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-lg-20 py-10 border-bottom border-grey-200">
        <div className="container-xl">
          <div className="row justify-content-center align-items-center gx-xl-5 mb-5">
            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
              <div className="d-flex justify-content-between align-items-start gap-3">
                <h2 className="text-xl-8xl text-md-6xl text-sm-4xl text-xl font-bold">
                  Popular category
                </h2>
                <a
                  href="#"
                  className="text-decoration-nonebtn py-2 btn btn-outline-light font-semibold text-primary-800 d-inline-flex align-items-center gap-1"
                >
                  View All <i className="bx bx-right-arrow-alt bx-sm"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="row justify-content-center align-items-center gy-3">
            {jobsPopularCategoryListLoading ? (
              <LoadingScreen />
            ) : (
              jobsPopularCategoryList.length > 0 &&
              jobsPopularCategoryList.map((item, index) => (
                <div
                  className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12"
                  key={`${item.gid}-${index}`}
                >
                  <a
                    href="#"
                    className="job-works-list text-decoration-none p-4 rounded-lg d-flex gap-3 align-items-center text-inherit"
                  >
                    <div className="job-works-icon flex-none size-16 border border-primary-200 rounded-lg d-flex justify-content-center align-items-center bg-primary-50 overflow-hidden">
                      <img
                        src={
                          item.icon
                            ? item.icon
                            : "/assets/images/placeholders/job-category-placeholder.svg"
                        }
                        alt={item.title}
                        className="w-100 h-100 object-fit-cover"
                      />
                    </div>

                    <div>
                      <h4 className="mb-1 text-md font-semibold">
                        {item.title}
                      </h4>
                      <p className="mb-0 text-grey-500">
                        {item.openPositions} Open Position
                      </p>
                    </div>
                  </a>
                </div>
              ))
            )}
          </div>
        </div>
      </section>

      <section className="py-lg-20 py-10">
        <div className="container-xl">
          <div className="row justify-content-center align-items-center gx-xl-5 mb-5">
            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
              <div className="d-flex justify-content-between align-items-start gap-3">
                <h2 className="text-xl-8xl text-md-6xl text-sm-4xl text-xl font-bold">
                  Featured job this week
                </h2>
                <a
                  href="#"
                  className="text-decoration-nonebtn py-2 btn btn-outline-light font-semibold text-primary-800 d-inline-flex align-items-center gap-1"
                >
                  View All <i className="bx bx-right-arrow-alt bx-sm"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="row gy-3 gx-sm-3">
            {loading ? (
              <LoadingScreen />
            ) : (
              featuredJobsList.length > 0 &&
              featuredJobsList.map((item, index) => (
                <div
                  className="col-xl-4 col-lg-3 col-md-6 col-sm-6 col-12"
                  key={`${item.gid}-${index}`}
                >
                  <JobBox jobData={item} />
                </div>
              ))
            )}
          </div>
        </div>
      </section>
    </main>
  );
}
